import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        width: '100%',
        padding: '16px 12px',
        backgroundColor: '#f8f9fa',
        borderTop: '1px solid #e0e0e0',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
        boxShadow: '0px -2px 4px rgba(0, 0, 0, 0.05)'
      }}
    >
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{
          fontWeight: 500,
          fontSize: '0.9rem',
          '& span': {
            color: '#1976D2',
            fontWeight: 700
          }
        }}
      >
        © {currentYear} <span>Glaciar Ingeniería</span>. Todos los derechos reservados.
      </Typography>
    </Box>
  );
};

export default Footer;
